export default "__VITE_ASSET__Cwnp0KpC__"